const WORDS = [
  "Landscaping",
  "Lawn Care",
  "Junk Removal",
  "Bobcat Services",
  "Lot Clearing",
  "Gravel Driveways",
  "Grading",
  "Demolition",
  "San Antonio",
];

export default function Marquee({ variant = "dark" }) {
  const bg = variant === "dark" ? "bg-[#0E2A1A]" : "bg-[#F5F3EE]";
  const fg = variant === "dark" ? "text-[#FFFFFF]" : "text-[#0E2A1A]";
  const accent = variant === "dark" ? "#DA7B3C" : "#DA7B3C";

  const items = [...WORDS, ...WORDS];

  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden ${bg} ${fg} py-10 md:py-14`}
    >
      <div className="marquee-track">
        {items.map((w, i) => (
          <div
            key={i}
            className="flex items-center gap-10 md:gap-16 pr-10 md:pr-16 shrink-0"
          >
            <span
              className="font-display italic text-6xl md:text-8xl leading-none tracking-[-0.02em] whitespace-nowrap"
              style={{ fontWeight: 400 }}
            >
              {w}
            </span>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              className="shrink-0"
              aria-hidden="true"
            >
              <circle cx="11" cy="11" r="4" fill={accent} />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
}
